<div class="flex h-full">
  @for (option of options; track $index) {
    <a
      class="flex flex-col items-center justify-center gap-2 px-2 py-1 text-white transition-all duration-200 hover:bg-white/20 hover:backdrop-blur-sm sm:flex-row sm:gap-2 sm:px-4 sm:py-2"
      routerLinkActive="bg-white/10 backdrop-blur-sm"
      [preserveFragment]="true"
      [routerLink]="option.route"
    >
      <span class="material-symbols-outlined text-sm sm:text-base">{{ option.icon }}</span>
      <span class="hidden text-xs font-medium sm:block sm:text-sm">{{ option.name }}</span>
      <span class="text-xs font-medium sm:hidden md:hidden">{{ option.shortName }}</span>
    </a>
  }
</div>
